// extracted by mini-css-extract-plugin
export default {"container":"Featured_container__B--Tz","row":"Featured_row__ehmA7","vinyls":"Featured_vinyls__9TUqM","blue":"Featured_blue__Xuqqn"};